(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ams-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  const key='__amsLivingRibbon';
  if(window[key]){window[key].scan();return;}
  const instances=new Map(), reduce=matchMedia('(prefers-reduced-motion: reduce)');
  const shapes={"intro":[[1040,110],[880,230],[580,120],[280,90],[80,250],[120,460],[380,490],[500,290],[360,170],[160,370],[150,700],[390,880],[700,720],[870,460],[1050,540],[1040,840],[840,1000]],"services":[[790,70],[1010,230],[960,470],[730,510],[510,340],[590,140],[340,110],[140,290],[220,550],[520,650],[740,510],[960,630],[930,850],[680,990],[400,900],[150,1020]],"work":[[50,280],[270,100],[570,190],[750,470],[600,690],[340,630],[280,390],[570,310],[910,430],[1050,710],[860,930],[570,990]],"studio":[[110,120],[170,380],[420,600],[730,560],[980,310],[820,120],[580,240],[500,540],[710,800],[970,860],[1030,1030]],"contact":[[60,200],[380,50],[840,150],[1080,410],[950,650],[620,610],[320,490],[130,650],[240,880],[620,1000],[1030,900]]};
  function curve(points){
    const fmt=p=>`${p[0].toFixed(2)},${p[1].toFixed(2)}`;
    let d=`M${fmt(points[0])}`;
    for(let i=1;i<points.length-1;i++){
      const a=points[i],b=points[i+1];
      d+=`Q${fmt(a)} ${fmt([(a[0]+b[0])/2,(a[1]+b[1])/2])}`;
    }
    return d+`Q${fmt(points[points.length-1])} ${fmt(points[points.length-1])}`;
  }
  function mount(root){
    if(instances.has(root))return;
    let frame=0,last=0,time=0,px=-3000,py=-3000,activeUntil=performance.now()+1600;
    const items=[];
    root.querySelectorAll('img.ams-thread,.ams-visual--thread img').forEach((img,index)=>{
      if(img.closest('.ams-panel--studio'))return;
      if(img.closest('.ams-panel--services') && img.classList.contains('ams-thread'))return;
      const id=`${root.id}-living-${index}`;
      const panel=img.closest('.ams-panel');
      const type=Object.keys(shapes).find(name=>panel.classList.contains(`ams-panel--${name}`))||'intro';
      const base=shapes[type];
      const svg=document.createElementNS('http://www.w3.org/2000/svg','svg');
      svg.setAttribute('viewBox','-120 -120 1367 1276');svg.setAttribute('aria-hidden','true');svg.setAttribute('focusable','false');
      svg.dataset.ribbonShape=type;
      svg.setAttribute('class',`${img.className} ams-living-ribbon`);
      svg.innerHTML=`<defs><linearGradient id="${id}-color" x1="0" y1="1" x2=".85" y2="0"><stop stop-color="#6869ac"/><stop offset=".28" stop-color="#6869ac"/><stop offset=".55" stop-color="#fa8334"/><stop offset=".7" stop-color="#fa8334"/><stop offset="1" stop-color="#d8cc34"/></linearGradient><filter id="${id}-grain" x="-15%" y="-15%" width="130%" height="130%" color-interpolation-filters="sRGB"><feTurbulence type="fractalNoise" baseFrequency=".75" numOctaves="1" stitchTiles="stitch" seed="8" result="noise"/><feColorMatrix in="noise" type="saturate" values="0"/><feComposite in2="SourceGraphic" operator="in"/><feBlend in="SourceGraphic" mode="soft-light"/></filter></defs><path fill="none" stroke="url(#${id}-color)" stroke-width="87" stroke-linecap="round" stroke-linejoin="round" filter="url(#${id}-grain)"/>`;
      const path=svg.querySelector('path');path.setAttribute('d',curve(base));
      img.after(svg);img.classList.add('ams-ribbon-fallback');
      items.push({img,svg,path,base,phase:index*1.6,visible:false,offsets:base.map(()=>[0,0]),rect:null});
    });
    function wake(){if(performance.now()>activeUntil){items.forEach(i=>{i.path.setAttribute('d',curve(i.base));i.offsets.forEach(o=>{o[0]=0;o[1]=0;});});return;}if(!frame&&!reduce.matches&&!document.hidden&&items.some(i=>i.visible))frame=requestAnimationFrame(draw);}
    const visibility=new IntersectionObserver(entries=>{entries.forEach(e=>{const item=items.find(i=>i.svg===e.target);if(item)item.visible=e.isIntersecting;});wake();},{rootMargin:'80px'});
    items.forEach(i=>visibility.observe(i.svg));
    function measure(){items.forEach(i=>{i.rect=i.svg.getBoundingClientRect();});}
    function draw(now){
      frame=0;
      if(reduce.matches||document.hidden)return;
      if(now-last<32){wake();return;}
      const dt=Math.min((now-last)/1000||.033,.05);last=now;time+=dt;
      const mobile=innerWidth<=760, amplitude=(mobile?.3:.45)*Math.min(1,Math.max(0,(activeUntil-now)/900));
      items.forEach(item=>{
        if(!item.visible)return;
        const r=item.rect, u=time*.65+item.phase;
        const points=item.base.map(([x,y],i)=>{
          const along=i/(item.base.length-1);
          const nx=x+amplitude*(Math.sin(u-along*5)*38+Math.sin(u*.63+along*3)*14);
          const ny=y+amplitude*(Math.cos(u*.82-along*4)*42+Math.sin(u*.47+along*3)*16);
          let dx=0,dy=0;
          if(r&&r.width&&!mobile){
            const unit=Math.min(r.width/1367,r.height/1276);
            const mx=(px-r.left-(r.width-1367*unit)/2)/unit-120;
            const my=(py-r.top-(r.height-1276*unit)/2)/unit-120;
            const distance=Math.hypot(mx-nx,my-ny),pull=Math.exp(-distance*distance/65000)*.24;
            dx=(mx-nx)*pull*amplitude;dy=(my-ny)*pull*amplitude;
          }
          const offset=item.offsets[i],blend=1-Math.exp(-dt*4);
          offset[0]+=(dx-offset[0])*blend;offset[1]+=(dy-offset[1])*blend;
          return [nx+offset[0],ny+offset[1]];
        });
        item.path.setAttribute('d',curve(points));
      });
      wake();
    }
    function scroll(){activeUntil=performance.now()+900;measure();wake();}
    function pointer(e){if(e.pointerType==='mouse'){px=e.clientX;py=e.clientY;activeUntil=performance.now()+900;wake();}}
    function leave(){px=py=-3000;}
    function preference(){
      cancelAnimationFrame(frame);frame=0;last=performance.now();
      root.classList.add('ams-living-active');
      if(reduce.matches)items.forEach(i=>i.path.setAttribute('d',curve(i.base)));
      measure();wake();
    }
    function visibilityChange(){last=performance.now();if(document.hidden){cancelAnimationFrame(frame);frame=0;}else wake();}
    const resize=new ResizeObserver(scroll);resize.observe(root);
    addEventListener('scroll',scroll,{passive:true});addEventListener('resize',scroll);
    root.addEventListener('pointermove',pointer,{passive:true});root.addEventListener('pointerleave',leave);
    document.addEventListener('visibilitychange',visibilityChange);reduce.addEventListener('change',preference);
    instances.set(root,()=>{cancelAnimationFrame(frame);visibility.disconnect();resize.disconnect();removeEventListener('scroll',scroll);removeEventListener('resize',scroll);root.removeEventListener('pointermove',pointer);root.removeEventListener('pointerleave',leave);document.removeEventListener('visibilitychange',visibilityChange);reduce.removeEventListener('change',preference);items.forEach(i=>{i.svg.remove();i.img.classList.remove('ams-ribbon-fallback');});root.classList.remove('ams-living-active');instances.delete(root);});
    preference();
  }
  function scan(){document.querySelectorAll('.ams-site').forEach(mount);document.querySelectorAll('[data-method-art]:not([data-method-ready])').forEach(art=>{art.dataset.methodReady='true';if(reduce.matches)return;art.classList.add('is-ready');const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){art.classList.add('is-visible');observer.disconnect();}},{threshold:.25});observer.observe(art);});}
  window[key]={scan};
  document.addEventListener('shopify:section:load',scan);
  document.addEventListener('shopify:section:unload',e=>{instances.forEach((destroy,root)=>{if(e.target.contains(root))destroy();});});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan,{once:true});else scan();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ams-progetto"]) return;
  try {
    
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  function magnet(h){
    const text=h.textContent.trim();
    h.setAttribute('aria-label',text);
    const wrap=document.createElement('span');wrap.setAttribute('aria-hidden','true');
    const colors=['#6869ac','#fa8334','#d8cc34'];
    const chars=[];let n=0;
    text.split(/(\s+)/).forEach(part=>{
      if(/^\s+$/.test(part)){wrap.appendChild(document.createTextNode(' '));return;}
      const w=document.createElement('span');w.className='amp-word';
      [...part].forEach(c=>{
        const s=document.createElement('span');s.className='amp-ch';s.textContent=c;
        s.style.setProperty('--i',n);s.style.setProperty('--c',colors[n%3]);
        w.appendChild(s);chars.push({el:s,x:0,y:0,r:0,sc:1,k:0,vx:0,vy:0});n++;
      });
      wrap.appendChild(w);
    });
    h.textContent='';h.appendChild(wrap);h.classList.add('is-split');
    if(reduce.matches)return;
    let px=-1e4,py=-1e4,frame=0,active=false;
    const R=150,PUSH=22;
    function step(){
      frame=0;let moving=false;
      const size=parseFloat(getComputedStyle(h).fontSize)/68;
      chars.forEach(c=>{
        const b=c.el.getBoundingClientRect();
        const cx=b.left+b.width/2-c.x,cy=b.top+b.height/2-c.y;
        const dx=cx-px,dy=cy-py,d=Math.hypot(dx,dy)||1;
        const f=active?Math.max(0,1-d/(R*Math.max(.7,size))):0;
        const e=f*f*(3-2*f);
        const tx=dx/d*e*PUSH*size,ty=dy/d*e*PUSH*size-e*6*size;
        const tr=(dx/d)*e*-14,ts=1+e*.18,tk=e>.1?100:0;
        c.vx=(c.vx+(tx-c.x)*.18)*.72;c.vy=(c.vy+(ty-c.y)*.18)*.72;
        c.x+=c.vx;c.y+=c.vy;c.r+=(tr-c.r)*.2;c.sc+=(ts-c.sc)*.2;c.k+=(tk-c.k)*.22;
        const st=c.el.style;
        st.setProperty('--x',c.x.toFixed(2)+'px');st.setProperty('--y',c.y.toFixed(2)+'px');
        st.setProperty('--r',c.r.toFixed(2)+'deg');st.setProperty('--s',c.sc.toFixed(3));st.setProperty('--k',c.k.toFixed(1)+'%');
        if(Math.abs(c.x)>.05||Math.abs(c.y)>.05||Math.abs(c.vx)>.05||c.k>.5)moving=true;
      });
      if(active||moving)frame=requestAnimationFrame(step);
    }
    const wake=()=>{if(!frame)frame=requestAnimationFrame(step);};
    const zone=h.closest('.amp-info')||h;
    zone.addEventListener('pointermove',e=>{if(e.pointerType!=='mouse')return;px=e.clientX;py=e.clientY;active=true;wake();},{passive:true});
    zone.addEventListener('pointerleave',()=>{active=false;wake();});
    const tch=e=>{const t=e.touches[0];if(!t)return;px=t.clientX;py=t.clientY;active=true;wake();};
    const tend=()=>{active=false;wake();};
    h.addEventListener('touchstart',tch,{passive:true});h.addEventListener('touchmove',tch,{passive:true});
    h.addEventListener('touchend',tend);h.addEventListener('touchcancel',tend);
  }
  function init(root){
    if(root.dataset.ampInit)return; root.dataset.ampInit='1';
    const title=root.querySelector('[data-amp-magnet]');if(title)magnet(title);
    const bar=root.querySelector('.amp-progress');
    const onScroll=()=>{const h=document.documentElement.scrollHeight-innerHeight;bar&&bar.style.setProperty('--amp-p',h>0?Math.min(1,scrollY/h):0);};
    addEventListener('scroll',onScroll,{passive:true});onScroll();

    const story=root.querySelector('[data-amp-story]');
    if(story){
      const rte=story.querySelector('.amp-rte'),btn=story.querySelector('.amp-more');
      if(rte.scrollHeight>rte.clientHeight+8){
        story.classList.add('is-clipped');btn.hidden=false;
        btn.addEventListener('click',()=>{
          const open=story.classList.toggle('is-open');
          btn.setAttribute('aria-expanded',open);
          btn.querySelector('[data-more]').hidden=open;btn.querySelector('[data-less]').hidden=!open;
        });
      }
    }

    if(!reduce.matches&&'IntersectionObserver' in window){
      const items=root.querySelectorAll('.amp-shot,.amp-quote,.amp-pager-link');
      items.forEach(el=>el.classList.add('amp-reveal'));
      root.classList.add('is-ready');
      const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}}),{rootMargin:'0px 0px -8% 0px'});
      items.forEach(el=>io.observe(el));
    }

    const dlg=root.querySelector('.amp-lightbox');
    if(!dlg)return;
    let imgs=[];try{imgs=JSON.parse(dlg.querySelector('[data-amp-images]').textContent);}catch(e){}
    const full=dlg.querySelector('[data-amp-full]'),count=dlg.querySelector('[data-amp-count]');
    let i=0,opener=null;
    function show(n){
      if(!imgs.length)return;
      i=(n+imgs.length)%imgs.length;
      full.classList.add('is-loading');
      full.onload=()=>full.classList.remove('is-loading');
      full.src=imgs[i].src;full.alt=imgs[i].alt||'';
      count.textContent=String(i+1).padStart(2,'0')+' / '+String(imgs.length).padStart(2,'0');
      [i+1,i-1].forEach(k=>{const im=new Image();im.src=imgs[(k+imgs.length)%imgs.length].src;});
    }
    root.querySelectorAll('[data-amp-open]').forEach(b=>b.addEventListener('click',()=>{
      opener=b;show(+b.dataset.ampOpen);
      if(dlg.showModal)dlg.showModal();else dlg.setAttribute('open','');
      document.documentElement.style.overflow='hidden';
    }));
    const close=()=>{if(dlg.open)dlg.close();};
    dlg.addEventListener('close',()=>{document.documentElement.style.overflow='';opener&&opener.focus();});
    dlg.querySelector('[data-amp-close]').addEventListener('click',close);
    dlg.querySelector('[data-amp-prev]').addEventListener('click',()=>show(i-1));
    dlg.querySelector('[data-amp-next]').addEventListener('click',()=>show(i+1));
    dlg.addEventListener('keydown',e=>{if(e.key==='ArrowRight')show(i+1);if(e.key==='ArrowLeft')show(i-1);});
    dlg.addEventListener('click',e=>{if(e.target.classList.contains('amp-lb-stage'))close();});
    let x0=null;
    dlg.addEventListener('touchstart',e=>{x0=e.touches[0].clientX;},{passive:true});
    dlg.addEventListener('touchend',e=>{if(x0===null)return;const dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>40)show(dx<0?i+1:i-1);x0=null;});
  }
  const scan=()=>document.querySelectorAll('[data-amp]').forEach(init);
  document.addEventListener('shopify:section:load',scan);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan,{once:true});else scan();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
